import organizationalChart from "@/api/human-resource/organizational-chart";
import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState,
    companies: []
};

export const getters = {};

export const mutations = {
    ...baseMutations,
    SET_COMPANIES(state, data) {
        state.companies = data;
    }
};

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return organizationalChart.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },

    store(context, data) {
        return organizationalChart.store(data);
    },

    update(context, { id, data }) {
        return organizationalChart.update(id, data);
    },

    destroy(context, id) {
        return organizationalChart.destroy(id);
    },
    async getCompany(context, attributes = {}) {
        let response = await organizationalChart.company({
            params: attributes
        });
        context.commit("SET_COMPANIES", response.data);
    }
};
